import { FC } from 'react';

import { useTranslations } from 'context/translations';
import { LandingPageContentKeys } from 'service/contentful/keys';
import { Accordion } from 'components';

import styles from './FAQBlock.module.css';

export const FAQBlock: FC = () => {
  const { content } = useTranslations();
  return (
    <div className={styles.container}>
      <Accordion
        items={content(LandingPageContentKeys.FAQBlockContent)}
        size="large"
        defaultIndex={0}
      />
    </div>
  );
};
